<i18n src="../../locales/lang.json"></i18n>

<template>
  <div class="fixed-bottom container-fluid d-none d-md-block">
    <div v-show="display == true && displayMessage != null" class="speech-bubble p-2 skin nux-bgcolor nux-textcolor ">
      <div class="row">
        <div class="col p-2 displaytext" v-show="display == true && displayMessage != null">
          <span class="skin nux-textcolor col-8 custom-center" v-html="displayMessage" style="float: left;"></span>
          <a href="#" class="btn btn-link btn-outline-white ml-2 skin nux-bgcolor nux-bordercolor " v-on:click="toggleVisibility();" style="float:left;color:inherit">{{$t('ok_got_it')}}</a>
          <a href="#" class="btn btn-link btn-outline-white ml-2 skin nux-bgcolor nux-bordercolor" v-on:click="removeHelpText();" style="float: left; color: inherit">{{$t('stop_showing')}}</a>
          <help-icon style="float:right"></help-icon>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  var message = "";
  var display = false;

  export default {
    name: "nux-desktop",
    components: {

    },
    props: {
    },
    data() {
      return {
        message: {
          required: false,
          type: String,
          default: null
        },
        display: {
          required: false,
          type: Boolean,
          default: null
        },
      };
    },

    methods: {
      removeHelpText() {
        setCookie("disablehelptext", true, 999, this.$store.getUsername());
        this.display = false;
      },
      toggleVisibility() {
        this.display = !this.display;
        this.$forceUpdate();
      },
      switchMessage(message) {
        /*
        if (message == null)
          alert("null message")
        else if (message == "")
          alert("empty message")
        else
          alert("message:" + message)
          */
        this.message = message;
      },
      handleRefresh(val) {
        this.$forceUpdate();
      },
      
    },
    computed: {
      displayMessage: function() {
        if (this.message != null && this.message != "" && typeof(this.message) != 'undefined')
          return this.message;
        return null;
      },
      isDisplayMessageVisible: {
        get() {
          return (this.display == true && this.displayMessage != null);
        }
      }
    },
    mounted() {
      var disable = getCookie("disablehelptext", this.$store.getUsername());
      if (disable == "true")
        this.display = false;
      else
        this.display = true;

      this.$root.$on('nux', this.switchMessage);
    },

    created: function () {

    },

    watch: {
      isDisplayMessageVisible(newValue) {
        this.$store.setHelptextVisible(newValue);
      },

    },
    created() {

    },
  };

</script>

<style scoped>
  .custom-center {
    top: 50%;
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
  }

  .speech-bubble {
    position: relative;
    background: #cce7ee;
    margin: -10px;
    margin-bottom: 0px;
    color: black !important;
    opacity: 0.7;
  }

    .speech-bubble:after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 50%;
      width: 0;
      height: 0;
      border: 0.75em solid transparent;
      border-top-color: transparent;
      border-bottom-color: transparent;
      border-bottom-style: solid;
      border-bottom-width: 0.75em;
      border-top-color: #cce7ee;
      border-bottom: 0;
      margin-bottom: -0.75em;
      z-index: 10000;
      opacity: 0.7;
    }

  .speech-bubble.element_1:after {
    margin-left: calc(-37% - 12px)
  }
  .speech-bubble.element_2:after {
    margin-left: calc(-11% - 12px)
  }
  .speech-bubble.element_3:after {
    margin-left: calc(13% - 12px)
  }
  .speech-bubble.element_4:after {
    margin-left: calc(38% - 12px)
  }

  .mobile-nav-submenuitem:focus, .mobile-nav-submenuitem:hover {
    color:black;
  }
  .mobile-nav-submenuitem {
    margin-left: 15px;
    color: #293a50;
    margin-top:5px;
  }

  .mobile-nav-submenuitem{
    margin-left:15px;
  }

  .mobile-nav-expanded-row {
    
    padding-bottom: 5px;
    background-color: #ccc;
  }
  .mobile-nav-button:focus, .mobile-nav-button:hover, .mobile-nav-button.selected {
    color: white !important;
  }

  .mobile-nav-button {
    color: #ccc;
  }

  .mobile-nav-bar {
    height: 80px;
    color: #ccc;
    background-color: #293a50 !important;
  }

  .mobile-nux-leftarrow {
    width: 5%;
    float: left;
  }

  .mobile-nux-center {
    width: 80%;
    margin-left: 5px;
    float: left;
    text-align: center;
  }

  .mobile-nux-rightarrow {
    width: 5%;
    float: right;
  }
  
</style>





// WEBPACK FOOTER //
// src/components/nux/nux-desktop.vue